import { Colors } from "@auteco/theme";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    headerContainer: {
        maxWidth: '1400px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px'
    },
    title: {
        margin: '20px 0 0 20px',
        fontSize: '20px',
        color: Colors.DARK_BLUE,
    },
    mainFiltersContainer: {
        maxWidth: '1400px',
        position: 'relative',
        paddingBottom: '40px',
        marginBottom: '40px'
    },
    filtersContainer: {
        maxWidth: '1400px',
        padding: '20px 0 10px',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
    },
    btnsContainer: {
        marginTop: '20px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    resetButton: {
        margin: '0 8px',
        backgroundColor: Colors.DARK_BLUE,
        color: 'white',
        '&:hover': {
            backgroundColor: Colors.DARK_BLUE,
        }
        // border: `2px solid ${Colors.DARK_BLUE}`,
        // color: Colors.DARK_BLUE
    },
    ejectBtn: {
        margin: '0 8px',
        width: '120px',
        backgroundColor: "#ff9800",
        color: 'white',
    },
    additionalFiltersContainer: {
        maxWidth: '1400px',
        display: 'flex',
        marginBottom: '20px'
    },
    additionalFilterContainer: {
        width: '400px',
        display: 'flex',
        flexDirection: 'column',
        padding: '15px 15px 60px 15px',
        position: 'relative',
        marginBottom: '20px'
        // alignItems: 'center',
        // justifyContent: 'space-between',
        // padding: '20px 0 20px 20px'
    },
    additionalFilterBtn: {
        width: '120px',
        position: 'absolute',
        backgroundColor: Colors.DARK_BLUE,
        color: 'white',
        right: '15px',
        bottom: 0
    }
}))

export default useStyles